import {Component, computed, input} from '@angular/core';
import {IACKATHON_STEP} from '../../models/iackathon_steps';
import {IackathonSave} from '../../services/iackathon-saves.service';
import {IackathonStepCanvasComponent} from './steps-details-components/iackathon-step-canvas/iackathon-step-canvas.component';
import {IackathonStepDeliverableComponent} from './steps-details-components/iackathon-step-deliverable/iackathon-step-deliverable.component';
import {IackathonStepFinalIdeaComponent} from './steps-details-components/iackathon-step-final-idea/iackathon-step-final-idea.component';
import {IackathonStepHowNowWowComponent} from './steps-details-components/iackathon-step-how-now-wow/iackathon-step-how-now-wow.component';
import {IackathonStepKeyNumberComponent} from './steps-details-components/iackathon-step-key-number/iackathon-step-key-number.component';
import {IackathonStepProblematicComponent} from './steps-details-components/iackathon-step-problematic/iackathon-step-problematic.component';
import {IackathonStepRateComponent} from './steps-details-components/iackathon-step-rate/iackathon-step-rate.component';
import {IackathonStepRatingOthersComponent} from './steps-details-components/iackathon-step-rating-others/iackathon-step-rating-others.component';
import {isIackathonStepCompleted, isIackathonStepLocked} from '../../models/iackathon-step-progress';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-iackathon-step-details',
    imports: [
        IackathonStepKeyNumberComponent,
        IackathonStepProblematicComponent,
        IackathonStepHowNowWowComponent,
        IackathonStepFinalIdeaComponent,
        IackathonStepCanvasComponent,
        IackathonStepDeliverableComponent,
        IackathonStepRatingOthersComponent,
        IackathonStepRateComponent,
        MatIconModule,
        MatTooltipModule,
        TranslateModule
    ],
  templateUrl: './iackathon-step-details.component.html',
})
export class IackathonStepDetailsComponent {
    step = input.required<IACKATHON_STEP>();
    save = input.required<IackathonSave>();

    private readonly state = computed(() => this.save()?.attributes.content.state);

    protected isStepCompleted(): boolean {
        return isIackathonStepCompleted(this.state(), this.step());
    }

    protected isStepLocked(): boolean {
        return isIackathonStepLocked(this.state(), this.step());
    }
}
